import { formatCurrency, formatPercentage } from "@roc/ui/utils";

export const getCurrentLoanTermValues = (loan: any) => {
  return {
    initialLoanAmount: loan?.initialLoanAmount,
    constructionHoldback: loan?.constructionHoldback,
    arltv: loan?.aggregateAfterRepairLoanToValue,
    interestReserveMonths: loan?.interestReserveMonths,
    rate: loan?.rate,
  }
}

export const getLoanTermApprovalValuesForDisplay = (loanTermApprovalValues: any) => {
  const loanAmount = loanTermApprovalValues?.loanAmount || 0;
  const constructionHoldback = loanTermApprovalValues?.constructionHoldback || 0;
  const initialLoanAmount = loanAmount - constructionHoldback;

  return {
    initialLoanAmount: initialLoanAmount,
    constructionHoldback: constructionHoldback,
    arltv: loanTermApprovalValues?.arltv || 0,
    interestReserveMonths: loanTermApprovalValues?.interestReserveMonths || 0,
    rate: loanTermApprovalValues?.rate || 0,
  }
}

export const getConfirmLoanTermsBanner = () => {
  return "Please go to the accept loan terms task - If you are comfortable with these terms, please proceed to committee. If not, please consult with an underwriter. Please note that the committee may revise loan terms further, if that occurs, you will go through this step again.";
}

export const getConfirmLoanTermsTextPending = (initialLoanAmount: any, constructionHoldback: any, arltv: any, rate: any, interestReserveMonths: any) => {
  return `We are offering you ${formatCurrency(initialLoanAmount)} initial and ${formatCurrency(constructionHoldback)} holdback on this loan, up to ${formatPercentage(arltv)} ARLTV, an interest rate of ${formatPercentage(rate)}, an interest reserve of ${interestReserveMonths} ${interestReserveMonths === 1 ? 'month' : 'months'}. If you are comfortable with these terms, please proceed to committee. If not, please consult with an underwriter. Please note that the committee may revise loan terms further, if that occurs, you will go through this step again.`;
}

export const getConfirmLoanTermsTextAccepted = (initialLoanAmount: any, constructionHoldback: any, arltv: any, rate: any, interestReserveMonths: any) => {
  return `Terms accepted were ${formatCurrency(initialLoanAmount)} initial and ${formatCurrency(constructionHoldback)} holdback on this loan, up to ${formatPercentage(arltv)} ARLTV, an interest rate of ${formatPercentage(rate)}, an interest reserve of ${interestReserveMonths} ${interestReserveMonths === 1 ? 'month' : 'months'}. Please note that the committee may revise loan terms further, if that occurs, you will go through this step again.`;
}